/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CountyLookupDbResponseDataModelApiModel } from '../../models/county-lookup-db-response-data-model-api-model';

export interface GetByZipcode$Params {
  zipcode: any;
}

export function getByZipcode(http: HttpClient, rootUrl: string, params: GetByZipcode$Params, context?: HttpContext): Observable<StrictHttpResponse<CountyLookupDbResponseDataModelApiModel>> {
  const rb = new RequestBuilder(rootUrl, getByZipcode.PATH, 'get');
  if (params) {
    rb.path('zipcode', params.zipcode, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CountyLookupDbResponseDataModelApiModel>;
    })
  );
}

getByZipcode.PATH = '/v1/counties/zips/{zipcode}';
